import type { ReactNode } from "react";
import { IconeSeta } from "../icones";

export type LadoDoDePara = { rotulo: string; valor: ReactNode; detalhe?: ReactNode };

/**
 * O que era e o que fica, lado a lado com a seta (no celular, um embaixo do outro): pra conferir uma troca antes de
 * confirmar, como a conta do Challenge que vira a conta Funded (spec 064). O lado novo fica em destaque tonal. Leitor de
 * tela ouve "de ... para ...", nao a seta.
 */
export function DePara({ rotulo, de, para, mono = false }: { rotulo: string; de: LadoDoDePara; para: LadoDoDePara; mono?: boolean }) {
  const lado = (l: LadoDoDePara, novo: boolean) => (
    <div className={`mtc-de-para__lado${novo ? " mtc-de-para__lado--novo" : ""}`}>
      <span className="mtc-de-para__rotulo">{l.rotulo}</span>
      <strong className={`mtc-de-para__valor${mono ? " mtc-mono" : ""}`}>{l.valor}</strong>
      {l.detalhe && <span className="mtc-de-para__detalhe">{l.detalhe}</span>}
    </div>
  );
  return (
    <div className="mtc-de-para" role="group" aria-label={rotulo}>
      {lado(de, false)}
      <span className="mtc-de-para__seta" aria-hidden="true"><IconeSeta tamanho={20} /></span>
      <span className="mtc-so-leitor">para</span>
      {lado(para, true)}
    </div>
  );
}
